<template>
    <tab-container
        class="conclusion-tab"
        :title="content.title"
    >
        <div
            :id="content.domId"
            class="scroll-placeholder"
        />
        <div
            v-for="(paragraph, i) in hubParagraphs"
            :key="`hub-${i}`"
            class="text-block"
        >
            {{ paragraph }}
        </div>
        <div class="text-secondary-teal">
            <a
                class="dh-button primary"
                :href="content.hubLink"
                target="_blank"
            >
                <span>Healthy Communities Hub</span>
                <span class="show-link">{{ content.hubLink }}</span>
            </a>
        </div>
        <div
            v-for="(paragraph, i) in dashboardParagraphs"
            :key="`dashboard-${i}`"
            class="text-block"
        >
            {{ paragraph }}
        </div>
        <div class="text-secondary-teal">
            <a
                class="dh-button primary"
                :href="content.dashboardLink"
                target="_blank"
            >
                <span>Visit the Dashboard</span>
                <span class="show-link">{{ content.dashboardLink }}</span>
            </a>
        </div>
        <div
            v-for="(paragraph, i) in impactParagraphs"
            :key="`impact-${i}`"
            class="text-block"
        >
            {{ paragraph }}
        </div>
        <div class="text-secondary-teal">
            <a
                class="dh-button primary"
                :href="content.impactLink"
                target="_blank"
            >
                <span>See the potential impact</span>
                <span class="show-link">{{ content.dashboardLink }}</span>
            </a>
        </div>
        <div
            v-for="(paragraph, i) in imageParagraphs"
            :key="`image-${i}`"
            class="text-block"
        >
            {{ paragraph }}
        </div>
        <div class="puzzle">
            <svg-inline
                id="AHSPuzzleImage"
                class="header-icon"
                src="AHSPuzzleImage"
            />
        </div>
    </tab-container>
</template>

<script>
import { select, selectAll } from 'd3-selection';
import SvgInline from '@/components/SvgInline.vue';
import TabContainer from './TabContainer.vue';

export default {
    components: {
        SvgInline,
        TabContainer
    },
    props: {
        content: {
            type: Object,
            required: true
        }
    },
    computed: {
        hubParagraphs() {
            if (typeof this.content.hubText === 'string') {
                return [this.content.hubText];
            }
            return this.content.hubText;
        },
        dashboardParagraphs() {
            if (typeof this.content.dashboardText === 'string') {
                return [this.content.dashboardText];
            }
            return this.content.dashboardText;
        },
        impactParagraphs() {
            if (typeof this.content.impactText === 'string') {
                return [this.content.impactText];
            }
            return this.content.impactText;
        },
        imageParagraphs() {
            if (typeof this.content.imageText === 'string') {
                return [this.content.imageText];
            }
            return this.content.imageText;
        }
    },
    async mounted() {
        await this.$nextTick();
        const pieces = selectAll('#AHS-Puzzle2 #PUZZLE>g:not(#dotted-puzzle)').remove();
        const links = this.content.links || {};
        pieces.each(function () {
            const piece = this;
            select('#AHS-Puzzle2 #PUZZLE')
                .append('svg:a')
                .attr('target', '_blank')
                .attr('xlink:href', () => links[piece.id])
                .on('mouseover', function () {
                    select(this).attr('transform', 'scale(1.2) translate(-30, -30)')
                        .raise();
                })
                .on('mouseout', function () {
                    select(this)
                        .attr('transform', 'scale(1)')
                        .lower();
                })
                .append(() => this);
        });
    }
};
</script>

<style src="./common.tab.css" scoped></style>
<style src="./common.section.css" scoped></style>
<style lang="postcss" scoped>
.svg-inline-container {
  @apply w-full mt-4 max-w-2xl;
}

.text-block {
    @apply mt-4;
}

a {
    @apply inline-block mt-4 mb-8 max-w-2xl;
}

a:hover {
    color: #54BFAD !important;
    text-decoration: none !important;
    filter: brightness(90%);
}

span.show-link {
    display: none;
}
</style>
<style lang="postcss">
svg#AHSPuzzleImage {
    overflow: visible;
    min-height: 400px;
}
</style>
